import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const InformationItem = ({ text, label, href, icon, hideIcon }) => {
  return (
    <div className="flex items-center gap-1">
      <Icon icon={icon} size={18} color="primary" />
      <Typography variant="p" size="small" color="neutral-700">
        {text}
      </Typography>
      <Button
        variant="link"
        className="h-fit p-0"
        iconRight={!hideIcon ? 'external-link-mono' : undefined}
        onClick={() => window.open(href, '_blank', 'noopener,noreferrer')}
        text={label}
      />
    </div>
  );
};

export default InformationItem;
